import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getError } from '../../model/selectors';
import { clearError } from '../../model/actions';
import { getErrorDetailsText } from '@shared/error';
import { ErrorModal } from '@shared/ui/ErrorModal';
import { useTranslation } from 'react-i18next';
const ErrorManager = ({ confirmBtn, cancelBtn, onConfirm, onCancel, onClose }) => {
    const { t } = useTranslation('ErrorManager');
    const dispatch = useDispatch();
    const error = useSelector(getError);
    const detailsText = getErrorDetailsText(error === null || error === void 0 ? void 0 : error.details);
    const handleClearError = () => {
        dispatch(clearError());
    };
    const handleCloseError = () => {
        handleClearError();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const handleConfirm = () => {
        handleClearError();
        onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
    };
    const handleCancel = () => {
        handleClearError();
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    };
    if (!error) {
        return null;
    }
    return (React.createElement(ErrorModal, { isOpen: !!error, header: t('ErrorManagerModal.Header'), title: error.title || t('ErrorManagerModal.Title'), message: error.message || t('ErrorManagerModal.Message'), details: error.details, detailsText: detailsText || t('ErrorManagerModal.DetailsText'), detailsTitle: t('ErrorManagerModal.DetailsTitle'), detailsDescription: t('ErrorManagerModal.DetailsDescription'), confirmBtn: confirmBtn || t('ErrorManagerModal.ConfirmButton'), cancelBtn: cancelBtn, onClose: handleCloseError, onConfirm: handleConfirm, onCancel: onCancel ? handleCancel : undefined }));
};
export default ErrorManager;
